// @ts-nocheck
/* eslint-enable */
import styled from 'styled-components';
import { fontSize } from 'app/shared/styles/_fontsize';
import { colors } from 'app/shared/styles/_colors';
import { padding } from 'app/shared/styles/_spacing';

// Components
import Linker from 'app/shared/modules/Linker';

export const PageNavContainer = styled.nav`
  ${padding.top._2x};
  ${padding.bottom._2x};

  /* Add desktop horizontal padding to match Container wrapper */
  @media (min-width: 768px) {
    padding-left: 16px;
    padding-right: 16px;
  }
`;

export const PageNavOuterOrderedList = styled.ol`
  display: flex;
  justify-content: space-between;
  width: 100%;
  list-style: none;
  line-height: 2;
  font-size: ${fontSize['$font-size-md']};
`;

export const PrevNextLinker = styled(Linker)`
  ${(props) =>
    props.isActive &&
    `
        font-weight: bold;
        color: ${colors['$hpx-blue-600']}
    `}
  ${(props) =>
    props.isBold &&
    `
        font-weight: bold;
    `}
`;

export const PageLinker = styled(PrevNextLinker)`
  width: 100%;
`;

export const FirstPageLi = styled.li`
  min-height: 32px;
  min-width: 32px;
  display: flex;
  text-align: center;
  ${(props) =>
    props.showDots &&
    `
        &:after {
            padding-left: 8px;
            content: '...';
        }
    `}
`;

export const MiddlePagesLi = styled.li`
  min-height: 32px;
  min-width: 32px;
  display: flex;
  text-align: center;
`;

export const LastPageLi = styled.li`
  min-height: 32px;
  min-width: 32px;
  display: flex;
  text-align: center;

  ${(props) =>
    props.showDots &&
    `
        &:before {
            padding-right: 8px;
            content: '...';
        }
    `}
`;

export const PrevPageContainer = styled.li`
  display: flex;
  width: 25%;
`;

export const NextPageContainer = styled.li`
  display: flex;
  justify-content: flex-end;
  width: 25%;
`;

export const IconArrow = styled.img`
  position: relative;
  top: -1px;
  ${(props) =>
    props.direction === 'left' &&
    `
        transform: rotate(90deg);
        margin-right: 4px;
    `}

  ${(props) =>
    props.direction === 'right' &&
    `
        transform: rotate(270deg);
        margin-left: 4px;
    `}
`;
